import { useEffect, useRef, useState } from 'react';
import { FiMoreHorizontal } from 'react-icons/fi';
import { useLocation } from 'react-router-dom';

// A non-modal disclosure: nested search dialogs and create menus keep their
// existing focus handling and remain mounted when the viewport changes.
export default function PortalHeaderTools({ children }) {
    const [open, setOpen] = useState(false);
    const root = useRef(null);
    const trigger = useRef(null);
    const { pathname, search } = useLocation();
    useEffect(() => { setOpen(false); }, [pathname, search]);
    useEffect(() => {
        const media = window.matchMedia?.('(min-width: 768px)');
        if (!media) return;
        const resize = () => { if (media.matches) setOpen(false); };
        media.addEventListener?.('change', resize);
        if (!media.addEventListener) media.addListener(resize);
        return () => {
            media.removeEventListener?.('change', resize);
            if (!media.removeEventListener) media.removeListener(resize);
        };
    }, []);
    useEffect(() => {
        if (!open) return;
        const outside = (event) => {
            if (!root.current?.contains(event.target) && !event.target.closest('.p-dialog, .p-sidebar, .p-menu, .p-dropdown-panel')) setOpen(false);
        };
        const escape = (event) => {
            if (event.key !== 'Escape' || event.defaultPrevented || document.querySelector('[aria-modal="true"], .p-menu-overlay')) return;
            setOpen(false);
            trigger.current?.focus();
        };
        document.addEventListener('pointerdown', outside);
        document.addEventListener('keydown', escape);
        return () => {
            document.removeEventListener('pointerdown', outside);
            document.removeEventListener('keydown', escape);
        };
    }, [open]);
    return <div className="portal-header-tools" ref={root} data-open={open}>
        <button type="button" ref={trigger} className="portal-more-trigger portal-button" aria-label="More actions" aria-expanded={open} aria-controls="portal-header-tools" onClick={() => setOpen((value) => !value)}>
            <FiMoreHorizontal aria-hidden="true" /><span>More</span>
        </button>
        <div id="portal-header-tools" className="portal-header-tools-panel" role="region" aria-label="Portal actions">{children}</div>
    </div>;
}
